const Dutch = {
  // MENU ITEMS
  routes: 'Routes',
  performance: 'Prestaties',
  ships: 'Schepen',
  fleet: 'Vloot',
  whatIsNew: 'Wat is nieuw',
  aboutCovadem: 'Over CoVadem',
  selectLanguage: 'Taal',
  disclaimer: 'Disclaimer',
  signOut: 'Uitloggen',
  accountSettings: 'Account',
  covadem: 'CoVadem',

  // ROUTES
  today: 'Vandaag',
  stationName: 'Naam locatie',
  waterLevel: 'Waterstand',
  ruleOfThumb: 'Vuistregel',
  lowestLoadingDepth: 'Laagste aflaaddiepte',
  lowestRuleOfThumbLoadingDepth: 'Laagste vuistregel aflaaddiepte',
  latestUpdate: 'laatste update',
  moreInformation: 'Meer informatie',
  lowestWaterDepth: 'Maximaal beschikbare waterdiepte',
  currentlyNotShowingDueToFiltering: ' niet zichtbaar door filter instellingen',
  from: 'Van',
  to: 'Tot',
  passADate: 'Geef een datum op',
  showMap: 'Toon kaart',
  bridges: 'Brug',
  pegels: 'Peilschaal',
  lowestBridgeClearance: 'Laagste doorvaarthoogte',
  type: 'Type',
  KM: 'KM',
  name: 'Naam',
  bridgeClearance: 'Hoogte',
  tendency: 'Tendens',
  routeStart: 'Beginpunt',
  routeEnd: 'Eindpunt',
  loadingDepth: 'Aflaaddiepte',
  loadingDepthRuleOfThumb: 'Aflaaddiepte - Vuistregel',
  squatTrim: 'squat/trim',
  extraSafetyMargin: 'Veiligheidsmarge',
  showAll: 'Toon alles',
  noTableData: 'There is no Table Data',
  location: 'locatie',
  notAvailable: 'Niet beschikbaar',
  sections: 'Secties',
  showSelections: 'Toon selectie',
  both: 'Beide',
  searchNotFound: 'Geen resultaten gevonden',
  locationSearchPlaceholder: 'Zoek locatie',
  distance: 'afstand',
  via: 'via',
  noRouteAvailable: 'Geen route beschikbaar',
  selectRoute: 'Selecteer een route',
  loading: 'Laden',
  waterLevelRepresentsValueAt: 'Waterstand vertegenwoordigt waarde bij',

  // MAP
  showTable: 'Toon lijst',
  more: '...Meer',
  draft: 'Diepgang',

  // MAP LEGEND
  shallow: 'Ondiep',
  deep: 'Diep',

  // PERFORMANCE
  emptySelection: 'Selecteer uw instellingen',
  clickReset: 'Klik op de knop "Laden / reset"',
  performanceOverallTitle: 'Algemene informatie',
  showMyPerformance: 'Toon mijn prestaties',
  selectAPeriod: 'Selecteer periode',
  selectADateAndTime: 'Selecteer datum en tijd',
  period: 'Periode',
  minUKCThreshold: 'Kielspeling grens',
  minUKCThresholdCM: 'Kielspeling grens (CM)',
  culture: 'nl',
  /* FIXME: this is currently not used, but maybe it will be in the future with logbooks */
  // dropDownData: [
  //   { id: 'minute', name: 'Minuut' },
  //   { id: 'hour', name: 'Uur' },
  //   { id: 'day', name: 'Dag' },
  //   { id: 'month', name: 'Maand' },
  //   { id: 'year', name: 'Jaar' },
  // ],
  export: 'Exporteer',
  exportStep1: 'Kies eenheden',
  exportStep2: 'Export',

  // PERF OVERVIEW
  // labels
  labels: {
    fuelFlowAverage: 'Gem Brandstofverbruik',
    speedAverage: 'Gem Snelheid',
    UKCAverage: 'Gem Kielspeling',
    draftAverage: 'Gem Diepgang',
    squatAverage: 'Gem Squat',
    cargoWeightAverage: 'Gem belading',
  },

  // perf. summary/overall
  distanceTotal: 'Afgelegde afstand',
  speedAverage: 'Gemiddelde snelheid',
  fuelTotal: 'Totaal verbruik brandstof',
  co2Total: 'Totale CO2 uitstoot',
  UKCAverage: 'Gemiddelde Kielspeling',
  UKCMinimal: 'Kleinst Waargenomen Kielspeling',
  cargoWeightAverage: 'Gemiddelde belading',

  fuelTKm: 'Brandstofverbruik',
  csv: 'CSV',
  xlsx: 'XLSX (Excel)',

  co2TotalTooltip: `CoVadem berekent de CO2 uitstoot op basis van de vastgestelde Tank-to-Wheel (TTW) CO2- emissiefactor 
                    per liter fossiele diesel. (2, 657kg CO2 / liter diesel) Deze waarden zijn online te vinden op {0}. 
                    Gebruikt u een ander type brandstof, dan gelden andere emissiewaarden.`,

  // SHIPS
  ship: 'Schip',
  box: 'Box',
  boxType: 'Type CoVadem Box',
  boxNumber: 'CoVadem Box s/n',

  sensorWorking: 'Werkend',
  sensorWarning: 'Waarschuwing',
  sensorError: 'Fout',
  sensorUnavailable: 'Niet beschikbaar',

  sensors: 'Sensoren',
  sensorTypeBox: 'Box',
  sensorTypeGPS: 'GPS',
  sensorTypeHDOP: 'HDOP',
  sensorTypeCargo: 'Belading',
  sensorTypeEcho: 'Dieptemeter',
  sensorTypeFuel: 'Brandstofverbruiksmeter',

  shipData: 'Schip Data',
  shipName: 'Scheepsnaam',
  ENINumber: 'ENI nummer',

  shipConstructionYear: 'Bouwjaar',
  shipLength: 'Lengte',
  shipWidth: 'Breedte',
  shipHeight: 'Doorvaarthoogte',
  shipWeight: 'Waterverplaatsing',
  shipMaxCargoWeight: 'Max cargo gewicht',
  shipMaxDraft: 'Max diepgang',

  // FLEET
  speed: 'Snelheid (km/h)',
  cargo: 'Gewicht lading (tons)',
  tons: 'Ton',
  fuel: 'Brandstofverbruik (l)',
  ukc: 'Kielspeling (m)',

  // ACCOUNT
  email: 'Email',
  fullName: 'Voor-en achternaam',
  companyName: 'Bedrijfsnaam',
  signedUp: 'Ingeschreven',
  noMeasuringShips: 'Geen metende schepen',
  // ships: 'Ships',

  // NOTIFICATIONS
  errorOccurred: 'Er is een fout opgetreden',
  reloadPage: 'Laadt de pagina opnieuw',
  anotherUserLoggedIn:
    'Het ziet er naar uit dat er nog een actieve sessie is op een ander device',
  tokenExpired: 'Uw inlogcode is is verlopen',
  logInAgain: 'Logt u alstublieft opnieuw in',
  appUpdatesMessage:
    'Het CoVadem platform is uitgebreid en verbeterd. Klik op meer info voor een uitgebreid overzicht.',
  errorMessage: 'Er is een fout opgetreden.',
  offlineMessage:
    'Er is geen internet verbinding. Controleer uw Wifi or mobiele netwerk.',
  moreInfoButton: 'meer info',
  retry: 'probeer opnieuw',
  announcementTitle: 'Storing',
  announcementMessage: `Onze excuses, de weergegeven waardes in het dashboard zijn op dit moment niet zoals u van ons mag verwachten. 
                        Dit komt door een storing in ons systeem.Het probleem is inmiddels verholpen maar het kan nog enkele dagen duren 
                        voordat alle data weer opnieuw is opgebouwd, en er in het dashboard weer de juiste waardes worden weergegeven.`,

  daysDurationLimit: 'Het maximaal toegestane bereik is binnen {0} dagen.',

  // VALUES
  liter: 'Liter',
  ltr: 'Ltr',
  literAbbreviation: 'L',
  kilogram: 'Kilogram',
  kilometer: 'Kilometer',
  km: 'Km',
  meter: 'Meter',
  meterAbbreviation: 'M',
  kilometerPerHour: 'Km/H',
  meterPerSecond: 'M/s',
  literPerHour: 'l/u',
  gramTonKilometer: 'gr/t/km',
  literTonKilometer: 'l/t/km',

  // Export window
  expDateTimeDescription: 'Datum en tijd (UTC)',
  expCountTotalDescription: 'Aantal metingen',
  expGPSPathDescription: 'GeoJSON LineString (enkel bij CSV)',
  expDegrees: 'Graden (0 tot 360)',
  expGeoJsonPoint: 'Geojson point',
  expLatLongSingle: '1 kolom',
  expLatLongDouble: '2 kolommen',

  // OTHERS
  comingSoon: 'Binnenkort',
  show: 'Toon',
  moreOpt: 'Instellingen',
  dropDownPlaceholder: 'Kies een optie',
  dropDownSearchPlaceholder: 'Type om te zoeken',
  loadResetData: 'Laden / reset',
  retryData: 'Opnieuw',
  cancel: 'Annuleren',

  // PAGES
  aboutCovademContent: 'Voor meer informatie kijkt u op',

  // UNSPECIFIED
  map: 'Kaart',
  table: 'Lijst',
  navbarRoute: 'Routes',
  navbarPerformance: 'Prestaties',
  navbarShip: 'Schip',
  navbarMore: 'Meer',
  languages: 'Talen',
  english: 'English',
  dutch: 'Nederlands',
  german: 'Deutsch',
  french: 'Français',
  startDateError: 'Startdatum is verplicht',
  endDateError: 'Einddatum is verplicht',
  periodError: 'Periode is verplicht',
  selectedShipError: 'Selecteer een schip',
  dataNotAvailable: 'Geen data beschikbaar',
  noDataError: 'Geen data beschikbaar voor geselecteerde periode',
  indicator: 'Trend',
  navNow: 'Nu',
  navDay: 'Dag',
  navMonth: 'Maand',
  navYear: 'Jaar',
  days: 'dagen',
  routeDetailsButton: 'toon route details',
  loadingShips: 'Schepen worden geladen…',
  selectShip: 'Selecteer uw schip',
  changePeriod: 'Pas de instellingen aan',
  clickLogOut: 'Klik hier om uit te loggen',
  clickContinue: 'Klik hier om verder te gaan',
  backHome: 'Ga terug naar de homepagina',
  errorScreen: 'Foutmelding',
  dataSharing: 'Gegevens delen',
  showLowestWarnings: 'Toon kritieke punten',
  waterChartTitle: 'Verschil waterstand',
  clearanceChartTitle: 'Verschil doorvaarthoogte brug',
  chartError: 'Niet beschikbaar op dit moment.',
  graphNow: 'nu',
  graphDay: 'd',
  unavailable: 'Onbeschikbaar',
  basis: 'basis',
  stuckedButton: 'Ik zit vast, laad de pagina opnieuw',
  ruleOfThumbAppliedWarningMessage:
    'We hebben helaas niet genoeg waarden om een exacte positie te geven voor de laagste waterdiepte.',

  // ADVERTISEMENT
  becomeMeasuringShipTitle: 'CoVadem biedt voordeel voor metende schepen',
  becomeMeasuringShipWarn: `U heeft nog geen metende schepen, vandaar dat we op deze pagina geen informatie kunnen tonen. 
                            Wist u dat u daardoor een interessante korting misloopt ? De korting kan oplopen tot meer dan 200 euro per jaar!`,
  becomeMeasuringShipSubTitle: 'Meten is weten',
  becomeMeasuringShipDescription: `Maar meten doet u niet alleen voor CoVadem, of voor de korting, want: meten is weten! 
                                  Met CoVadem kunt u de prestaties(zoals verbruik, belading, gevaren afstand, emissies) monitoren over tijd. 
                                  Zo genereert u belangrijke inzichten waarmee u uw prestaties doorlopend kunt verbeteren. 
                                  Inzicht waarmee u ook het effect van innovaties of aanpassingen aan schip of bedrijfsvoering kunt monitoren! 
                                  Bovendien kunt u bijdragen aan de kwaliteit van de waterdiepte-informatie die we als CoVadem genereren.`,
  becomeMeasuringShipContact: `Meer weten, of direct aanmelden als metend schip ?
  Neem contact op voor de mogelijkheden! Bel 088 - 2682300 of laat uw informatie achter via { 0 }, 
                              en we nemen zo snel mogelijk contact op.`,
};

export default Dutch;
